/**
 * Wrapper for WBReactTable for consistent styling.
 */

import {Colors} from '@wandb/common/css/globals.styles';
import styled from 'styled-components';

import WBReactTable from '../WBReactTable';

export const Table = styled(WBReactTable)<{
  border?: string;
}>`
  margin-bottom: 0;
  border: ${p => p.border ?? `1px solid ${Colors.GRAY_350}`};

  .searchbox .wbic-ic-search {
    color: ${Colors.GRAY_500};
  }
  a {
    font-weight: 600;
    color: ${Colors.TEAL_DARK} !important;
    &:hover {
      color: ${Colors.TEAL_LIGHT} !important;
    }
  }
`;
Table.displayName = 'S.Table';
